import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable, catchError, finalize, throwError } from "rxjs";
import { AuthService } from "@core/auth/auth.service";
import { LoaderService } from "@core/services/loader/loader.service";
import { API_ENDPOINTS } from "@shared/consts/endpoints";
import { Router } from "@angular/router";
import { OidcLoginContextService } from "@core/auth/oidc-login-context.service";

@Injectable()
export class JwtInterceptor implements HttpInterceptor {
  constructor(
    private authService: AuthService,
    private loaderService: LoaderService,
    private router: Router,
    private oidcLoginContext: OidcLoginContextService
  ) { }

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    if (!request.url.includes(API_ENDPOINTS.REFRESH)) {
      this.loaderService.showLoader();
    }

    request = this.addAuthToken(request);

    return next.handle(request).pipe(
      finalize(() => {
        this.loaderService.hideLoader();
      }),
      catchError((error: HttpErrorResponse) => {
        this.loaderService.hideLoader();
        
        if ([0, 401, 403].includes(error.status))
          this.router.navigate([this.oidcLoginContext.getPendingConfigIdPath()]);

        return throwError(() => error);
      })
    );
  }

  addAuthToken(request: HttpRequest<any>): HttpRequest<any> {
    const token = this.authService.getToken();

    if (token) {
      request = request.clone({
        setHeaders: {
          Authorization: `Bearer ${token}`
        }
      });

      if (!this.authService.timeToken()) {
        request.headers.set("Authorization", `Bearer ${token}`);
      }
    }
    return request;
  }
}
